//Modal result enum values should follow the linked convention
//https://docs.microsoft.com/en-us/dotnet/api/system.windows.forms.dialogresult?view=netframework-4.7.2

export enum ModalResult {
    None = 0,
    Ok = 1,
    Cancel = 2
}